/* eslint-disable no-new */
const init = async (slider, SwiperLib) => {
  const scrollbar = slider.querySelector('.swiper-scrollbar');
  const navNextEl = slider.querySelector('.swiper-button-next');
  const navPrevtEl = slider.querySelector('.swiper-button-prev');
  const slides = slider.querySelectorAll('.swiper-slide');
  if (slides.length > 1) {
    new SwiperLib(slider, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      slidesPerGroup: 1,
      speed: 600,
      watchOverflow: true,
      roundLengths: true,
      navigation: {
        nextEl: navNextEl,
        prevEl: navPrevtEl,
      },
      scrollbar: {
        el: scrollbar,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
      },
    });
  }
};

export default init;
